<section class="trace-dashboard">
  <app-page-header
    title="Trazabilidad de Preservación"
    subtitle="Estado de las ingestas, expedientes en cuarentena y recorrido del archivo (incorporación → máster → consulta → actualización)."
    icon="Activity"
    [actions]="headerActions()"
    (actionClick)="onHeaderAction($event)"
  />

  @if (error()) {
    <p class="trace-dashboard__error">{{ error() }}</p>
  }

  <!-- Métricas agregadas (semáforo del tenant) -->
  @if (metrics(); as m) {
    <div class="trace-dashboard__cards">
      <div class="trace-dashboard__card">
        <span class="trace-dashboard__card-value">{{ m.total_ingestas }}</span>
        <span class="trace-dashboard__card-label">Ingestas totales</span>
      </div>
      <div class="trace-dashboard__card trace-dashboard__card--warn">
        <span class="trace-dashboard__card-value">{{ m.en_cuarentena }}</span>
        <span class="trace-dashboard__card-label">En cuarentena</span>
      </div>
      <div class="trace-dashboard__card">
        <span class="trace-dashboard__card-value">{{ tasaCuarentenaPct() }}%</span>
        <span class="trace-dashboard__card-label">Tasa de cuarentena</span>
      </div>
      <div class="trace-dashboard__card">
        <span class="trace-dashboard__card-value">{{ m.total_objetos_preservados }}</span>
        <span class="trace-dashboard__card-label">Objetos preservados</span>
      </div>
    </div>

    @if (estados().length) {
      <div class="trace-dashboard__estados">
        @for (e of estados(); track e.estado) {
          <span class="trace-dashboard__badge">{{ e.estado }}: {{ e.n }}</span>
        }
      </div>
    }
  }

  <!-- Abrir el recorrido de cualquier ingesta por su ID -->
  <div class="trace-dashboard__open">
    <lib-input
      label="Abrir recorrido por ID de ingesta"
      placeholder="Ej: 1024"
      [(value)]="ingestIdToOpen"
    />
    <lib-button variant="secondary" type="button" (clicked)="openById()">
      Abrir recorrido
    </lib-button>
  </div>

  <!-- Todas las ingestas -->
  <h3 class="trace-dashboard__section-title">Ingestas ({{ ingestsTotal() }})</h3>
  @if (loading()) {
    <p class="trace-dashboard__hint">Cargando…</p>
  } @else if (ingests().length === 0) {
    <p class="trace-dashboard__hint">Aún no hay ingestas registradas.</p>
  } @else {
    <lib-table
      [config]="ingestsTableConfig()"
      [data]="ingests()"
      [pageSize]="tablePageSize()"
      [pageSizeOptions]="tablePageSizeOptions"
      (action)="onIngestAction($event)"
    />
  }

  <!-- Expedientes en cuarentena (foco: requieren atención, con su motivo) -->
  @if (quarantined().length > 0) {
    <h3 class="trace-dashboard__section-title">Expedientes en cuarentena</h3>
    <lib-table
      [config]="tableConfig()"
      [data]="quarantined()"
      [pageSize]="tablePageSize()"
      [pageSizeOptions]="tablePageSizeOptions"
      (action)="onTableAction($event)"
    />
  }
</section>
